// @owners { team: patients }
import { useQuery } from '@tanstack/react-query';
import { queries } from './query-keys';
import { useDispatchShared } from '~shared/store';

/**
 * Loads a single prescription via GET /v3/prescriptions/:id. TanStack Query returns any cached
 * `data` for this query key immediately while refetching in the background per `staleTime`.
 */
export const usePrescription = ({
  prescriptionID,
  enabled,
}: {
  prescriptionID: number | null | undefined;
  enabled: boolean;
}) => {
  const dispatch = useDispatchShared();
  const { data, isLoading, refetch, error } = useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ...queries.prescriptions.prescription({ dispatch, prescriptionID: prescriptionID! }),
    enabled: enabled && !!prescriptionID,
  });

  return {
    isLoading,
    prescription: data,
    refetchPrescription: refetch,
    error,
  };
};
